(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('offer-status', {
            parent: 'entity',
            url: '/offer-status?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.offerStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/offer-status/offer-statuses.html',
                    controller: 'OfferStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('offerStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('offer-status-detail', {
            parent: 'entity',
            url: '/offer-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.offerStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/offer-status/offer-status-detail.html',
                    controller: 'OfferStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('offerStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OfferStatus', function($stateParams, OfferStatus) {
                    return OfferStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('offer-status.new', {
            parent: 'offer-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/offer-status/offer-status-dialog.html',
                    controller: 'OfferStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('offer-status', null, { reload: true });
                }, function() {
                    $state.go('offer-status');
                });
            }]
        })
        .state('offer-status.edit', {
            parent: 'offer-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/offer-status/offer-status-dialog.html',
                    controller: 'OfferStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OfferStatus', function(OfferStatus) {
                            return OfferStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('offer-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('offer-status.delete', {
            parent: 'offer-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/offer-status/offer-status-delete-dialog.html',
                    controller: 'OfferStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OfferStatus', function(OfferStatus) {
                            return OfferStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('offer-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
